export default "__VITE_ASSET__3ba73f20__"